<div class="dashboard-container">
    <div class="summary-cards">
      <div class="card total-active">
        <div class="card-content">
          <h2>My Reimbursement Requests</h2>
          <div class="card-info">
            <div class="number">0</div>
            <span>TOTAL ACTIVE</span>
          </div>
        </div>
        <div class="card-status">
          <div class="submitted">
            <div>0</div>
            <span>SUBMITTED</span>
          </div>
          <span class="plus-sign">+</span>
          <div class="completed">
            <div>0</div>
            <span>COMPLETED</span>
          </div>
        </div>
      </div>
  
      <div class="team-requests">
        <div class="team-card">
          <div class="count">0</div>
          <span>PENDING REQUESTS</span>
        </div>
        <div class="team-card">
          <div class="count">0</div>
          <span>APPROVED REQUESTS</span>
        </div>
        <div class="team-card">
          <div class="count">0</div>
          <span>RETURNED REQUESTS</span>
        </div>
        <div class="team-card">
          <div class="count">0</div>
          <span>REJECTED REQUESTS</span>
        </div>
        <div class="team-card">
          <div class="count">0</div>
          <span>AD-HOC REQUESTS</span>
        </div>
      </div>
    </div>
  
    <div class="requests-table">
      <h3>My Active Requests</h3>
      <div class="tabs">
        <button class="tab active">Open</button>
        <button class="tab">Disbursed</button>
        <button class="tab">Draft</button>
      </div>
  
      <table>
        <thead>
          <tr>
            <th>Request Id <input type="text" placeholder="Search" /></th>
            <th>Submission Date <input type="text" placeholder="Search" /></th>
            <th>Expense Type <input type="text" placeholder="Search" /></th>
            <th>Amount <input type="text" placeholder="Search" /></th>
            <th>Status <input type="text" placeholder="Search" /></th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr>
            <td>2015-16/EMS/07012015-131</td>
            <td>23/03/2015</td>
            <td>Mobile Handset</td>
            <td>10000</td>
            <td>Submitted</td>
            <td class="actions">
              <button class="view">👁️</button>
              <button class="edit">✏️</button>
              <button class="delete">❌</button>
            </td>
          </tr> -->
          <!-- Repeat rows as necessary -->
        </tbody>
      </table>
    </div>
  </div>
  